
import { Location, CommonModule } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { ApplicationRef, ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, ElementRef, EmbeddedViewRef, EventEmitter, HostListener, Injector, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { Observable, Subject, Subscription } from 'rxjs';
import { AppSettings } from 'src/app/services/AppSettings';
import { CandidateService } from 'src/app/services/CandidateService';
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { UserService } from 'src/app/services/UserService';
import { ApiService } from 'src/app/services/api.service';
import { candidateModel } from 'src/app/services/candidateModel';
import { CommonValues } from 'src/app/services/commonValues';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { JobService } from 'src/app/services/job.service';
import { JobModel } from 'src/app/services/jobModel';
import { jobModuleConfig } from 'src/app/services/jobModuleConfig';
import { WorkExperience } from 'src/app/services/userModel';
import { UtilService } from 'src/app/services/util.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { CustomValidator } from '../../Helper/custom-validator';
import { PricePlanService } from '../../Price-subscritions/priceplanService';
import { CandidateTemplateComponent } from '../../candidate-template/candidate-template.component';
import { SearchData } from './../../../services/searchData';
import { ConnectionTemplateComponent } from '../../../templates/connection-template/connection-template.component';
// import { NewJobComponent } from '../../../page/homepage/layout-jobs/new-job/new-job.component'; // Removed to break circular dependency
import { MessageWidgetComponent } from '../../../widget/message-widget/message-widget.component';
import { TimezoneDatePipe } from '../../../timezone-date.pipe';
import { FlagComponent } from '../../flag/flag.component';
import { TruncatePipe } from '../../../pipe/TruncatePipe.pipe';
import { CompactCountPipe } from '../../../pipe/compact-count.pipe';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { DndDirective } from 'src/app/directives/dnd.directive';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';

declare var $: any;

@Component({
  selector: 'app-candidates-page',
  standalone: true,
  // Note: NewJobComponent removed from imports to break circular dependency
  imports: [BsDropdownModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    CandidateTemplateComponent,
    ConnectionTemplateComponent,
MessageWidgetComponent,
    TimezoneDatePipe,
    FlagComponent,
    TruncatePipe,
    CompactCountPipe,
    CommonSkeletonComponent,
    DndDirective
  ,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './candidates-page.component.html',
  styleUrls: ['./candidates-page.component.scss'],
  providers: []
})
export class CandidatesPageComponent extends FormValidation implements OnInit, OnDestroy, OnChanges {

  /** Report Candidate hidden app-wide until the reporting flow is built.
   *  See the note on JobCardComponent.reportEnabled; grep "reportEnabled". */
  reportEnabled = false;
  private wasInside = false;
  public FORMERROR = super.Form;
  @Output() candidateReload = new EventEmitter<any>()
  selectedCurrency: string = '';
  tempFile: any;
  rtrformgrp: UntypedFormGroup;
  candidateSupplyRef: BsModalRef;
  @Output() candidateListing = new EventEmitter();
  filterStatusList: { itemId: any; value: any; }[] = [];
  @Input() loadAPIcall: boolean;
  filterloadSubcription: Subscription;
 private isTabSwitching = false;
  @HostListener('click')
  clickInside() {
    this.wasInside = true;
  }
  @HostListener('document:click')
  clickout() {
    if (!this.wasInside) {
      this.searchData.setCandiHighLight('null');
    }
    this.wasInside = false;
  }
  @Input() passValues: Array<candidateModel> = [];
  @Input() responseReceived: any;
  @Input() viewSize: any;
  @Input() removeSelected: any;
  @Input() jobData: any;
  @Input() Obj: any;
  @Input() updateCandidateModule: jobModuleConfig;
  passCandidateData: any;
  @Input() removeTag: any;
  @Input() CheckboxforBusinessJobs: Boolean = false;
  @Output() passValuesUpdate = new EventEmitter<any>();

  profileDetailResponse: any;
  ProfileComplete: any = {}

  @Input() candidatesFoundStatus: any;
  @Input() fromApply: boolean = false;
  CandiIdHighLight: any
  userId = localStorage.getItem("userId")
  appSettings: AppSettings
  submited: boolean = false;
  showmodel = false

  userType = localStorage.getItem('userType');
  removetagValueget: any;
  flag: boolean = true;
  filtersApplied: boolean = false
  @Input() data: any;
  @Input() dataPasstoSkillwidgets: any[];
  url = AppSettings.photoUrl;
  Resurl = AppSettings.ServerUrl;
  updateDate: any = [];
  jobfilter: boolean = false;
  GigsumoConstant = GigsumoConstants;
  unit = { duration: '30' };
  @Output() selectedCandidate: EventEmitter<any> = new EventEmitter()
  @Output() removeSeletedUser: EventEmitter<any> = new EventEmitter()
  @Output() updateStatusAndFilters: EventEmitter<any> = new EventEmitter()
  @ViewChild("myFileInputcandidate") myFileInputcandidate;
  dataget
  checkcount: number = 0;
  checkedList: any = [];
  FormData: any;
  PrimaryResumeFormData: any;

  fileSize = AppSettings.FILE_SIZE;
  clickItemActive: any;
  @Output() suggjob: EventEmitter<any> = new EventEmitter()
  bsModalRef: BsModalRef;
  public envName: any = environment.name;
  @ViewChild("myFileInput") myFileInput;
  @ViewChild("myFileInput1") myFileInput1;
  @ViewChild("myFileInput2") myFileInput2;
  imageChangedEvent: any = "";
  fileUploadName;
  fileToUpload: File;

  photoId: any;
  totaljobcount: any
  infoData: any = {};
  photo: any = null;
  fileshow = undefined;
  object: any;
  download = AppSettings.photoUrl;
  seletedChatItem;
  messageData: any;

  messagemodelflag: any
  loadscribtion: Subscription;
  currentTimeDate: string | Date;
  loadDate: any = [];
  API: any;
  tempData: any = [];
  networkflag: boolean = false
  firstName: any;
  lastName: any;
  creditPoints: any;
  primaryEmail: any;
  jobCountry: string;
  targetRates: string;
  jobPayType: string;
  selectedJobTitle: string;
  filtersAppliedbtn: boolean = true;
  items: any = {
  };
  clickEventsubscription: Subscription;
  updateCandidateListSubx: Subscription;
  focus: string;



  BackBreadCream() {
    this._location.back();
  }


  LandingPage() {
    this.router.navigate(["landingPage"]);
  }
  rtrpayType: any;
  observableFinalised: boolean = false;
  jobId: any;
  jobPostedBehalfOf: any
  ngunsubscribe = new Subject();
  createSubjectSubscription: Subscription;
  termCheckSubscription: Subscription;
  selectedItem: any;
  itemsLoaded: boolean = false;

  // Dynamic component loading for NewJobComponent (circular dependency fix)
  // Template reference to access after modal renders
  @ViewChild('jobsupplytemplate', { static: false }) jobsupplytemplate: TemplateRef<any>;
  private newJobContainer: ViewContainerRef | null = null;
  private newJobComponentRef: ComponentRef<any> | null = null;
  dropdownCoordinatorSubscription: Subscription = null as any;

  constructor(private JobServicecolor: JobService,  private userService: UserService, private apiService: ApiService,
    private commonValues: CommonValues,   private planService: PricePlanService,
    private formBuilder: UntypedFormBuilder, private _location: Location, private searchData: SearchData, private modalService: BsModalService,
    private router: Router, public util: UtilService,   private candidateService: CandidateService,
    public gigsumoService: GigsumoService, private cdr: ChangeDetectorRef, private injector: Injector) {
    super();
    this.searchData.getCandiHighLight().subscribe(res => {
      if (res != 'candiId') {
        this.CandiIdHighLight = res
      }
    });
    this.userId = localStorage.getItem('userId');

    this.createSubjectSubscription = this.searchData.getCreateSubjectCandidate().subscribe((res) => {
      if (res == true) {
        this.createANewSubject();
      }
    });

    this.updateCandidateListSubx = this.commonValues.getCandidateData().subscribe(candidateObject => {
      this.updateCandidateObject(candidateObject);
    });


    this.filterloadSubcription = this.searchData.getfilterReload().subscribe(val => {
      if (val === 'reload') {
        this.candidateReload.emit(val);
      }
    });

    // Listen for dropdown state changes from detail header to close candidate card dropdowns
    this.dropdownCoordinatorSubscription = this.searchData.getDropdownState().subscribe(state => {
      if (state.open && state.type === 'detail-header') {
        this.openKebabId = null;
        this.openStatusId = null;
        this.cdr.detectChanges();
      }
    });


  }


  BusinessJobChecked(checked, id) {
    let index = this.passValues.findIndex(item => item.candidateId === id.candidateId);
    if (checked) {
      this.passValues[index].transferCandidate = true;
      this.updateValues(checked);
    } else if (!checked) {
      this.passValues[index].transferCandidate = false;
      this.updateValues(checked);
    }
  }

  updateValues(flag) {
    let data: any = {};
    data.flag = flag;
    data.response = this.passValues;
    this.passValuesUpdate.emit(data);
  }



  ngOnChanges(changes: SimpleChanges): void {
    if (changes.passValues && changes.passValues.currentValue != undefined) {
      this.passValues = changes.passValues.currentValue;
      this.onSyncWithJobSubmitSkiller();
      // Sync FormArray with new passValues from infinite scroll
      this.syncFormArrayWithPassValues();
    }
    if (changes.Obj && changes.Obj.currentValue) {
      this.selectedItem = changes.Obj.currentValue.candidateId;
    }
    if (changes.candidatesFoundStatus && changes.candidatesFoundStatus.currentValue) {
      this.candidatesFoundStatus = changes.candidatesFoundStatus.currentValue;

    }
  }

  shouldShowRequested(items: any): boolean {

    return (items?.resumeRequested || this.util.isResumeRequested(items.candidateId, localStorage.getItem('userId'))) &&
      (!items?.resumes || items.resumes.length === 0) &&
      items?.createdBy != this.userId &&
      this.userType != 'BENCH_RECRUITER' &&
      this.userType != 'JOB_SEEKER';
  }


  onSyncWithJobSubmitSkiller() {
    this.passValues.forEach((res, index) => {
      if (res.remove) {

        this.selectedCandidateData.splice(index, 1);
        this.rtrContent.controls.forEach((ele, rtrindex) => {
          this.updateByCandidateId(ele, res.candidateId, rtrindex);
        });
      }
    });
  }

  syncFormArrayWithPassValues() {
    if (!this.rtrContent || !this.passValues) return;
    const currentLength = this.rtrContent.length;
    if (this.passValues.length > currentLength) {
      for (let i = currentLength; i < this.passValues.length; i++) {
        const element: any = this.passValues[i];
        element.candidateName = element.firstName + " " + element.lastName;
        this.rtrContent.push(this.pushRtrFormFields(element, this.jobData));
      }
    }
  }

  activejobcount: number;
  loadApply: boolean = false;
  ngOnInit() {
    this.gigsumoService.loadMyBusinessId();
    if (!this.applyResumeUploadData) {
      this.applyResumeUploadData = [];
    }
    this.updatejobcount();
    if (this.viewSize === 'extra-small') {
      this.loadApply = true;
      this.inititializertrform();
      this.getAppliedFilter();
    }
    if (this.userType != "JOB_SEEKER") {
      this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS")
    }
    this.ProfileComplete = this.commonValues.getUserData();
    this.userType = localStorage.getItem('userType')
    if (this.data != null) {
      this.flag = false;
    }

    this.passValues.forEach(element => {
      if (element.isSelected != undefined)
        element.isSelected = false;
    });
  }
  //adjust the button padding size in exta small popup by monisha
  getStatusLabelStyle(items: any): { [key: string]: string } {
    const baseStyle = this.getStyle(items?.currentStatus || items?.inviteStatus) || {};
    const padding = this.getFilterValue(items) ? '2px 5px' : '0';
    return { ...baseStyle, padding };
  }
  getFilterValue(data: any) {
    let arrs: Array<any> = [];
    let find: any = {};
    const raw = data.currentStatus || data.inviteStatus;
    if (data.currentStatus && data.currentStatus != null) {
      arrs = this.filterStatusList ? [...this.filterStatusList] : [];
      find = arrs.find(c => c.itemId === data.currentStatus);
    }
    else {
      arrs = this.filterStatusList ? [...this.filterStatusList] : [];
      find = arrs.find(c => c.itemId === data.inviteStatus);
    }

    // Fall back to a prettified raw status (e.g. "L3-INTERVIEW" → "L3
    // Interview") when the backend `listvalue/findbyList` master list
    // doesn't carry an entry for it. Without this, candidates whose
    // current status is L1/L2/L3 INTERVIEW (or any status not surfaced
    // by JOB_APPLICATION_SUPPLIER_ACTIONS / JOB_INVITATION_SUPPLIER_ACTIONS
    // / JOB_APPLICATION_BLOCKING_ACTIONS) show no pill at all in the
    // apply popup.
    if (find) return find.value;
    if (!raw) return null;
    return String(raw)
      .replace(/[-_]+/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, c => c.toUpperCase());
  }

  getAppliedFilter() {
    this.apiService.create('listvalue/findbyList', { domain: "JOB_INVITATION_SUPPLIER_ACTIONS,JOB_APPLICATION_BLOCKING_ACTIONS,JOB_APPLICATION_SUPPLIER_ACTIONS" }).subscribe(res => {
      const arraysToMerge = [
        res.data.JOB_APPLICATION_SUPPLIER_ACTIONS.listItems,
        res.data.JOB_INVITATION_SUPPLIER_ACTIONS.listItems,
        res.data.JOB_APPLICATION_BLOCKING_ACTIONS.listItems //probably this is not required.
      ]
      let mergedArray: any[] = []
      arraysToMerge.forEach(array => {
        if (Array.isArray(array) && array.length > 0) {
          mergedArray = mergedArray.concat(array)
        }
      })
      if (mergedArray.length > 0) {
        this.filterStatusList = mergedArray.map(x => {
          return { itemId: x.itemId, value: x.value };
        });
      }
    });
  }

  shouldShowGetResume(items: any): boolean {
    const resumesPresent = Array.isArray(items.resumes) && items.resumes.length > 0;
    const condition =
      items.createdBy != this.userId &&
      !resumesPresent &&
      !this.util.isResumeRequested(items.candidateId, localStorage.getItem('userId')) &&
      !items.resumeRequested;
    return condition;
  }


  async updatejobcount() {
    let planbenefits: any = await this.apiService.lamdaFunctionsget('findUserPlanBenefits/' + localStorage.getItem('userId'));
    this.activejobcount = planbenefits.data && planbenefits.data.activeJobsCount != undefined ? planbenefits.data.activeJobsCount : 0;

  }

  ngOnDestroy(): void {
    if (this.loadscribtion && !this.loadscribtion.closed) {
      this.loadscribtion.unsubscribe();
    }

    if (this.updateCandidateListSubx) {
      this.updateCandidateListSubx.unsubscribe();
    }


    if (this.clickEventsubscription) {
      this.clickEventsubscription.unsubscribe();
    }
    if (this.filterloadSubcription) {
      this.filterloadSubcription.unsubscribe();
    }
    if (this.dropdownCoordinatorSubscription) {
      this.dropdownCoordinatorSubscription.unsubscribe();
    }
    // Clean up dynamically loaded component
    if (this.newJobComponentRef) {
      const appRef = this.injector.get(ApplicationRef);
      appRef.detachView(this.newJobComponentRef.hostView);
      this.newJobComponentRef.destroy();
      this.newJobComponentRef = null;
    }
  }


  getButtonColor(item: any): string {
    if (this.filtersApplied) {
      if (item.currentStatus == null && item.inviteStatus != 'INITIATED' && item.inviteStatus != 'REJECTED') {
        return '#8B5CF6'; // Set the color for 'Available'
      } else if (item.currentStatus == null && item.inviteStatus == 'INITIATED') {
        return '#8B5CF6'; // Set the color for 'Invited'
      } else if (item.status == 'DRAFTED') {
        return '#ffb606'; // Set the color for 'Draft'
      } else if (item.currentStatus == null && item.inviteStatus == 'REJECTED') {
        return '#fe4052'; // Set the color for 'Rejected'
      }
    }
    return '#8B5CF6';
  }

  completeSubscription(): void {
    this.ngunsubscribe.complete()
  }

  nextSubscription(): void {
    this.ngunsubscribe.next(true)
  }

  createANewSubject(): void {
    this.ngunsubscribe = new Subject();
  }

  isFormInitialised: boolean = false
  targetrate: any
  RtrpayType: any
  country: any
  inititializertrform() {
    setTimeout(() => {
      this.loadApply = false;
    }, 3000);
    this.rtrformgrp = this.formBuilder.group({
      rtrcontent: this.formBuilder.array([]),
      termsandcondition: [true, Validators.requiredTrue]
    });

    if (this.passValues && this.passValues.length > 0) {
      this.passValues.forEach((element: any, index: number) => {
        element.candidateName = element.firstName + " " + element.lastName
        this.rtrContent.push(this.pushRtrFormFields(element, this.jobData));
        // this.updateResumeAtached(element , index);
      });
    }

  }

  updateResumeAtached(element: any, index: number) {


    if ((element.resumes === null || element.resumes === undefined) || (element.resumes != null && element.resumes.length === 0)) {
      this.rtrContent.at(index).get('resumeAttached').setValidators([Validators.required]);
      this.rtrContent.at(index).get('resumeAttached').updateValueAndValidity();
    }
  }

  updateByCandidateId(element: any, candidateId, index: number) {
    if (element.get('candidateId').value === candidateId) {
      this.rtrContent.at(index).get('resumeAttached').clearValidators();
      this.rtrContent.at(index).get('resumeAttached').updateValueAndValidity();
    }
  }

  termAndCondition: boolean = false;
  pushRtrFormFields(candidateData: candidateModel, jobData: JobModel) {
    return this.formBuilder.group({
      candidateName: [candidateData.candidateName, Validators.required],
      candidateId: [candidateData.candidateId, Validators.required],
      targetrate: [candidateData.targetRateTo, Validators.compose([Validators.required, CustomValidator.validDecimal(), CustomValidator.checkWhiteSpace()])],
      RtrpayType: [candidateData.payType, Validators.required],
      resumeAttached: [''],
      customError: [false],
      country: [candidateData.country],
    });
  }



  get rtrFormControls() {
    return this.rtrformgrp.controls
  }

  widgetReload(data) {
    // this.clickItemActive=data;
    this.suggjob.emit(data);
  }

  change() { }
  posted: Date;
  statusupdate: Date;
  curr: any
  // Blocks re-entry while a status change is in flight. checkUserPlanValid()
  // is a network round trip, so without this a second "Make Available" click
  // lands before the first resolves and both reach expiredPopup() — showing
  // the "Not Enough Jobs / Candidate Slots" popup twice. Same pattern as
  // job.component.ts `isProcessingStatusChange`.
  isProcessingStatusChange: boolean = false;
  async candidateStatus(event, values) {
    if (this.isProcessingStatusChange) {
      return;
    }
    this.isProcessingStatusChange = true;

    // Close the controlled status dropdown. Its option (click) calls
    // stopPropagation() (to keep the row inert), which also swallows the
    // outside-click that ngx-bootstrap uses to fire isOpenChange(false) — so
    // without clearing openStatusId the menu stayed open after selecting a status.
    this.openStatusId = null;

    try {
      if (event == 'ACTIVE') {


        const isPlanValid = await this.planService.checkUserPlanValid("JOB_CANDIDATE_POSTINGS", "JOBS_CANDIDATES");
        if (isPlanValid) {
          this.afterPlanValidationstatuschange(event, values);
        }

      } else {
        this.afterPlanValidationstatuschange(event, values);
      }
    } finally {
      // Small tail so the rapid second click of a double-click is still caught
      // after the await resolves.
      setTimeout(() => {
        this.isProcessingStatusChange = false;
      }, 500);
    }
  }
  isClicked: boolean = false;
  async downloadResume(data, userId, FileId) {

    if (this.isClicked) {
      return;
    }
    this.isClicked = true;
    if (!data.resumeDownloaded && data.createdBy != this.userId) {
      const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
      let { membershipType } = userData;
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;

      if (userData.userDetail) {
        userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
          if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
            availablePoints = ele.available;
            actualPoints = ele.actual;
            utilizedPoints = ele.utilized;
            promotional = ele.promotional;
          }
        });
      }
      if (userData.isExpired) {
        let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";
        if (['Starter', 'Growth', 'ScaleX'].includes(membershipType)) {
          popupType = "LIMIT";
        }
        this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);
        return;
      } else {
        this.afterPlanValidationDownloadResume(data, userId, FileId);
        data.resumeDownloaded = true;
        this.isClicked = false;

      }
    } else if (data.resumeDownloaded || data.createdBy === this.userId) {
      this.afterPlanValidationDownloadResume(data, userId, FileId);
    }
    setTimeout(() => {
      this.isClicked = false;
    }, 5000);

  }
  //download resume function by monisha
  afterPlanValidationDownloadResume(data, userId, FileId) {
    const endpoint = `candidates/resumeDownload/${data.candidateId}/${userId}/${data.createdBy}/${FileId}`;
    this.apiService.queryBlob(endpoint).subscribe(res => {
      const blob = new Blob([res]);
      // Backend stores resumes as `<uuid>_<originalFilename>.<ext>`. Strip
      // the UUID prefix so the saved download keeps the real extension —
      // without one, the OS opens the file as plain text.
      const raw = (data.resumes?.find(r => r.fileId === FileId)?.fileName || '').toString().trim();
      const uuidPrefix = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}_/;
      const fileName = (uuidPrefix.test(raw) ? raw.replace(uuidPrefix, '').trim() : raw) || 'resume.pdf';
      this.downloadFile(blob, fileName);
    });
  }

  userData = {
    userId: localStorage.getItem('userId'),
    userType: localStorage.getItem('userType')
  }
  //jobseeker candidate validation by monisha
  async afterPlanValidationstatuschange(event, values) {

    // job-seeker profile limit check in the plan service api
    if (this.passValues && event == 'ACTIVE' && this.userType === 'JOB_SEEKER') { 

      const isPlanValid = await this.planService.checkUserPlanValid("JOB_CANDIDATE_POSTINGS", "JOBS_CANDIDATES");
      if (!isPlanValid) return; 
         // Check job seeker profile limit for active candidate 
        if (this.planService.JobSeekerUpdate.activeCandidatesCount >= 1) {
          Swal.fire({
            position: "center",
            icon: "info",
            title: "Number of profiles exceeded.",
            text: "You can't create more than 1 profile for yourself as a job seeker.",
            showConfirmButton: true,
            showCancelButton: false,
          });
          return;
        } else {
          this.activatecanidates(event, values) 
        }
 
    } else {
      this.activatecanidates(event, values)
    }
  }
  activatecanidates(event, values) {
    try {
      this.util.stopLoader();
      values.status = event;
      this.candidateSubmit = true
      this.FormData = new FormData();
      // Only append resume if it's actually being uploaded (not null/empty)
      if (this.resumeupload != null && this.resumeupload !== '') {
        this.FormData.append("resume", this.resumeupload);
      }
      this.resumeupload = "";
      this.FormData = new FormData();
      values.candidateReferenceId = values.candidateId;
      if (localStorage.getItem('MemberShipType') !== 'Free') {
        values.businessId = localStorage.getItem('myBusinessId') || null;
      }
      this.FormData.append("candidate", new Blob([JSON.stringify(values)], { type: "application/json" }));
      this.apiService.updatePut("candidates/updateCandidate", this.FormData).subscribe(res => {
        if (res) {
          this.util.stopLoader();
          Swal.fire({
            icon: "success",
            title: "Candidate updated successfully",
            showDenyButton: false,
            showConfirmButton: false,
            timer: 2000,
          })
          if (res && res.data && res.data.candidateData) {
            let data: any = {};
            data.candidate = res.data.candidateData;
            this.updateStatusAndFilters.emit(data);
          }
        }
      });

    } catch (error) {
      this.util.stopLoader();
    }
  }

  downgradeCandidate(item) {
    let data: any = {}
    data = item;
    data.isFeatured = false;
    data.consumptionType = null;
    this.FormData = new FormData();
    // Only append resume if it's actually being uploaded (not null/empty)
    if (item.resume != null && item.resume !== '') {
      this.FormData.append("resume", item.resume);
    }
    data.candidateReferenceId = data.candidateId;
    if (localStorage.getItem('MemberShipType') !== 'Free') {
      (data as any).businessId = localStorage.getItem('myBusinessId') || null;
    }
    this.FormData.append("candidate", new Blob([JSON.stringify(data)], { type: "application/json" }));
    this.apiService.updatePut("candidates/updateCandidate", this.FormData).subscribe((res) => {
      this.util.stopLoader();
      if (res.code == '00000') {
        Swal.fire({
          icon: "success",
          title: "Downgraded Successfully",
          showDenyButton: false,
          showConfirmButton: false,
          timer: 2000,
        });

        if (res && res.data && res.data.candidateData) {
          let data: any = {};
          data.candidate = res.data.candidateData;
          this.candidateReload.emit("reload");
        }
      }
    }, err => {
      this.util.stopLoader();
    });
  }

  zipCodeValidaiton(x: number): boolean {
    if (String(x).length > 10) {
      return false;
    }
    return true;
  }

  enableCandidateedit(event) {
    if (event.target.checked == true) {
      this.object.status = 'ACTIVE'
    } else if (event.target.checked == false) {
      this.object.status = 'INACTIVE'
    }
    this.FormData = new FormData();
  }

  requestResumebyUser(value: any, index) {
    var data: any = {}
    data.candidateId = value.candidateId
    data.createdBy = this.userId
    data.resumeRequestLogs = [{ "jobId": null, "requestedBy": localStorage.getItem('userId') }]
    this.util.startLoader()
    this.apiService.updatePut('candidates/updateResumeRequests', data).subscribe(res => {
      if (res.code == '00000') {
        this.util.stopLoader()
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Resume request sent",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          value.resumeRequested = true;

          // if (this.passValues.length > 1) {
          //   this.passValues.splice(index, 1, value)
          // }

          // Updating resumeRequested to true for the matching candidateId in passValues by naaz
          this.passValues = this.passValues.map(val => {
            return val.candidateId === value.candidateId ? { ...val, resumeRequested: true } : val;
          })
        })

      }
    }, err => {
      this.util.stopLoader();
    });
  }

  onDownload() {
    const file: File = this.tempFile;
    this.downloadFile(new Blob([file]), file.name);
  }

  downloadFile(blob: Blob, fileName: string): void {
    const link = document.createElement('a');
    // create a blobURI pointing to our Blob
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    // some browser needs the anchor to be in the doc
    document.body.append(link);
    link.click();
    link.remove();
    // in case the Blob uses a lot of memory
    setTimeout(() => URL.revokeObjectURL(link.href), 0);
  }

  duplicateresume: boolean = false
  requestResume(values: any, index, connectionTemplate: TemplateRef<any>, jobsupplytemplate: TemplateRef<any>) {
    this.util.startLoader();
    setTimeout(() => {
      this.duplicateresume = true;
      this.passCandidateData = values;
      this.focus = 'resume';
      this.requestresumesent(values, index, jobsupplytemplate);
      this.duplicateresume = false;
      this.util.stopLoader();
    }, 3000);
  }

  async requestresumesent(values, index, jobsupplytemplate) {
    try {
      const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
      let { userDetail, isExpired, membershipType } = userData;
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      if (userDetail && userDetail.userPlanAndBenefits && userDetail.userPlanAndBenefits.benefitsUsages) {
        userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
          if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
            availablePoints = ele.available;
            actualPoints = ele.actual;
            utilizedPoints = ele.utilized;
            promotional = ele.promotional;
          }
        });
      } else {
        this.resumeopenmodal(values, index, jobsupplytemplate);
        this.util.stopLoader();
        return;
      }
      if (isExpired) {
        let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

        if (['Starter', 'Growth', 'ScaleX'].includes(membershipType)) {
          popupType = "LIMIT";

        }

        this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);

        this.gigsumoService.candidateInviteBtnClicked = false
        this.util.stopLoader();
        return;
      } else {
        this.resumeopenmodal(values, index, jobsupplytemplate);
      }
    } catch (error) {
    } finally {
      this.util.stopLoader();
    }

  }
  resumeopenmodal(values, index, jobsupplytemplate) {
    this.apiService.query("user/profile/complete/" + localStorage.getItem('userId')).subscribe(completerres => {
      this.totaljobcount = completerres.jobsCount;
      values.userId = localStorage.getItem('userId');
      values.candidatefilter = true;
      values.userType = values.user.userType;
      values.candidateId = values.candidateId;
      values.getResume = true;

      if (this.totaljobcount == 0) {
        this.requestResumebyUser(values, index);
      } else if ((this.totaljobcount > 0)) {
        const config: ModalOptions = { class: 'modal-lg', backdrop: 'static', keyboard: false };
        this.candidateSupplyRef = this.modalService.show(jobsupplytemplate, config);

        // Load NewJobComponent dynamically after modal is rendered
        setTimeout(() => {
          this.cdr.detectChanges();
          this.loadNewJobComponent();
        }, 150);
      }
    }, err => {
      this.util.stopLoader();
    });
  }
  
  figureLength: number = 0;
  payType: null;
  typeTargetValue: null;
  targetRate: any;
  countryChosen: null;
  updatedDate: string;
  availablepoints: any;
  //upgarde function for candidate by monisha
  async upgradeCandidate(item) {

     // if its free plan just open the credits modal
     if(this.MemberShipType === GigsumoConstants.FREE_PLAN){
      await this.creditsBasedUpgrade(item);
      return;
    }


    const isPlanValid = await this.planService.checkUserPlanValid("JOBS_CANDIDATE_SPOTLIGHTS" , "FEATURED");

    if(isPlanValid && (item.isFeatured === undefined || !item.isFeatured)){
      // FIX: Check if CREDITS was used today BEFORE using SPOTLIGHT
      // Get user's timezone date for comparison
      const profileResponse = await this.userService.userProfileDetails(this.userData);
      let currenttimezonedate = new Date(profileResponse.currentTimeByTimezone);
      currenttimezonedate.setHours(0, 0, 0, 0);

      if (this.wasUpgradedViaCreditToday(item, currenttimezonedate)) {
        // CREDITS was used today → redirect to creditsBasedUpgrade()
        // This will show the popup: "You will not be charged for this candidate again..."
        // On OK click → this.upgradeCandidates(item, 'CREDITS') → Uses CREDITS type
        await this.creditsBasedUpgrade(item);
      } else {
        // No CREDITS used today → proceed with SPOTLIGHT
        this.upgradeCandidates(item);
      }
    }
    else{
      this.creditsBasedUpgrade(item);
    }

  }

  /**
   * Checks if the candidate was upgraded via CREDITS today (not via SLOTS)
   * Used to determine if "already paid" message should be shown
   * Returns true if type=CREDITS regardless of credits value (even if 0)
   * This ensures re-upgrades after downgrade use CREDITS flow, not SPOTLIGHT
   */
  private wasUpgradedViaCreditToday(item: any, currentDate: Date): boolean {
    if (!item.featuredConsumptions || item.featuredConsumptions.length === 0) {
      return false;
    }

    // Find consumption entries for today
    const todayConsumptions = item.featuredConsumptions.filter(consumption => {
      const consumptionDate = new Date(consumption.fromDate);
      consumptionDate.setHours(0, 0, 0, 0);
      return consumptionDate.getTime() === currentDate.getTime();
    });

    // Check if any of today's consumptions used CREDITS type
    // Returns true if type=CREDITS regardless of credits value
    return todayConsumptions.some(consumption =>
      consumption.type?.toUpperCase() === 'CREDITS'
    );
  }

  async creditsBasedUpgrade(item){
    this.profileDetailResponse = await this.userService.userProfileDetails(this.userData);
    let currenttimezonedate = new Date(this.profileDetailResponse.currentTimeByTimezone);
    currenttimezonedate.setHours(0, 0, 0, 0);
    this.updatedDate = String(item.featuredUpdatedOn);
    let currentDates = this.util.dateFormatestring(this.updatedDate);
    this.availablepoints = this.profileDetailResponse.userCredits;
    let alertdate = new Date(this.profileDetailResponse.currentTimeByTimezone);
    if (item.isFeatured == undefined || currenttimezonedate > currentDates && item.isFeatured == false) {
      this.planService.expiredPopup("UPGRADE_CANDIDATES", "UPGRADE", item, currenttimezonedate, currentDates, alertdate, this.availablepoints, null, null, null);
    } else if (item.isFeatured == false) {
      // Check if previously upgraded via CREDITS today
      if (this.wasUpgradedViaCreditToday(item, currenttimezonedate)) {
        // Previous upgrade was via CREDITS - show "already paid" message
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        });

        swalWithBootstrapButtons
          .fire({
            title: 'You will not be charged for this candidate again for the day as it has already been paid for.',
            icon: "warning",
            showCancelButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: 'Ok',
            cancelButtonText: 'No',
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.upgradeCandidates(item, 'CREDITS');
            }
          });
      } else {
        // Previous upgrade was via SLOTS (not CREDITS) - open credit-based upgrade modal
        this.planService.expiredPopup("UPGRADE_CANDIDATES", "UPGRADE", item, currenttimezonedate, currentDates, alertdate, this.availablepoints, null, null, null);
      }
    }
  }


  async checkAlreadyPaid(item){
   this.profileDetailResponse = await this.userService.userProfileDetails(this.userData);
    let currenttimezonedate = new Date(this.profileDetailResponse.currentTimeByTimezone);
    currenttimezonedate.setHours(0, 0, 0, 0);
    this.updatedDate = String(item.featuredUpdatedOn);
    let featureddate = this.util.dateFormatestring(this.updatedDate);
    this.availablepoints = this.profileDetailResponse.userCredits;
    let alertdate = new Date(this.profileDetailResponse.currentTimeByTimezone);

    //Day end upgrade validation by monisha
    if (alertdate.getHours() >= 18 && (currenttimezonedate > featureddate && item.isFeatured == false|| item.isFeatured == null || item.isFeatured == undefined)) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "The day is about to end.",
          text: "Are you sure you want to upgrade until EOD?",
          icon: "warning",
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.upgradeCandidates(item,'CREDITS');
          }
        });
    } else {
      if (item.isFeatured === undefined ||(currenttimezonedate > featureddate && item.isFeatured === false)) {
        this.upgradeCandidates(item);
      } else if (item.isFeatured === false) {
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger',
          },
          buttonsStyling: false,
        });
  
        swalWithBootstrapButtons
          .fire({
            title: 'You will not be charged for this candidate again for the day as it has already been paid for.',
            // text: this.dynamicMessage,
            icon: "warning",
            showCancelButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: 'Ok',
            cancelButtonText: 'No',
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.upgradeCandidates(item,'CREDITS');
            } 
          });
      }
    }
  }

  upgradeCandidates(data : candidateModel, type?:any){
    this.FormData = new FormData();
    data.isFeatured = true;
    data.candidateReferenceId = data.candidateId;
    data.consumptionType = "JOBS_CANDIDATE_SPOTLIGHTS";
    if(type){
      data.consumptionType = type;
    }
    if (localStorage.getItem('MemberShipType') !== 'Free') {
      (data as any).businessId = localStorage.getItem('myBusinessId') || null;
    }
    this.FormData.append("candidate", new Blob([JSON.stringify(data)], { type: "application/json" }));
    this.apiService.updatePut("candidates/updateCandidate", this.FormData).subscribe((res) => {
        if(res.code === GigsumoConstants.SUCESSCODE){
          this.candidateReload.emit("reload");
           Swal.fire({
            icon: "success",
            title: "Candidate Upgraded Successfully",
            showDenyButton: false,
            showConfirmButton: false,
            timer: 2000,
  
          });
        }
    });
  }



  republishCandidate(item: any) {
    this.util.startLoader();
    const formData = new FormData();
    formData.append("candidate", new Blob([JSON.stringify(item)], { type: "application/json" }));
    this.apiService.updatePut("candidates/updateCandidate", formData).subscribe((res) => {
      this.util.stopLoader();
      if (res.code === GigsumoConstants.SUCESSCODE) {
        this.candidateReload.emit("reload");
        Swal.fire({
          icon: "success",
          title: "Candidate Republished Successfully",
          showDenyButton: false,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    }, err => {
      this.util.stopLoader();
    });
  }

  removecheckbox() {
    this.removeSeletedUser.emit(this.checkedList);
  }
  // Check values get
  selectedCandidateData: Array<any> = [];
  
  async selectCheckbox(event, candidateId: string, index?: any) {
    this.getCheckedItemList();
    const foundItems: Array<any> = this.passValues.filter(item => item.isSelected === true);

    if (event.target.checked && foundItems.length > this.planService.ACTIVE_INTERACTION) {

      const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
      let { membershipType } = userData;
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
        if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
          availablePoints = ele.available
          actualPoints = ele.actual
          utilizedPoints = ele.utilized
          promotional = ele.promotional
        }
      })
      let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

      if (['Starter', 'Growth', 'ScaleX'].includes(membershipType)) {
        popupType = "LIMIT";
      }
      this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);

      return
    }
    if (event.target.checked) {
      this.passValues.forEach((ele, index) => {
        if (ele.candidateId === candidateId) {
          ele.isSelected = true;
          this.updateResumeAtached(ele, index)
        }
        if (ele.isSelected) {
          this.selectedCandidateData.push(ele);
        }
      });
      var mySet = new Set(this.selectedCandidateData);
      this.selectedCandidateData = [...mySet];
      this.selectedCandidate.emit({ value: this.selectedCandidateData, formData: this.rtrContent, terms: this.termAndCondition, resumes: this.applyResumeUploadData });

    } else if (!event.target.checked) {
      if (this.selectedCandidateData.length > 0) {
        this.selectedCandidateData.forEach((element: any, i: number) => {
          if (element.candidateId === candidateId) {

            if (this.applyResumeUploadData.length > 0) {
              this.applyResumeUploadData.forEach((applyRes, index) => {
                if (applyRes.candidateId === candidateId) {
                  this.applyResumeUploadData.splice(index, 1);
                }
              });
            }

            this.rtrContent.controls.forEach((ele, rtrindex) => {
              this.updateByCandidateId(ele, candidateId, rtrindex);
            });

            this.selectedCandidateData.splice(i, 1);
            var mySet = new Set(this.selectedCandidateData);
            this.selectedCandidateData = [...mySet]
            this.selectedCandidate.emit({ value: this.selectedCandidateData, formData: this.rtrContent, terms: this.termAndCondition, resumes: this.applyResumeUploadData });

          }
        });
      }
      this.rtrContent.at(index).get('customError').setValue(true);
    }


  }

  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.passValues.length; i++) {
      if (this.passValues[i].isSelected) {
        this.checkedList.push(this.passValues[i]);
      }
    }

    this.checkedList = this.checkedList;

  }
  //showing colors for all images if candidate image is not presnet by monisha
  getInitials(fullname: string): string {
    return this.JobServicecolor.getInitials(fullname);
  }
  getColor(fullname: string): string {
    return this.JobServicecolor.getColor(fullname);
  }
  getFullNameTextColor(fullname: string): string {
    return this.JobServicecolor.getFullnameTextColor(fullname);
  }
  // for first and last name
  getInitialName(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }
  //showing first and lastname for all images if candidate image is not presnet by monisha
  getColorName(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }
  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }

  /**
   * Get the full photo URL, avoiding duplication if the photo already contains the base URL
   */
  getPhotoUrl(photo: string): string {
    if (!photo) {
      return '';
    }
    // If photo already starts with http/https, return as-is
    if (photo.startsWith('http://') || photo.startsWith('https://')) {
      return photo;
    }
    // Otherwise, prepend the base URL
    return this.download + photo;
  }

  checkConnectionStatus(values): Observable<any> {
    const apiURL = 'user/checkConnectionStatus';
    const params = new HttpParams()
      .set('userId', this.userId)
      .set('connnectorId', values.createdBy);

    const urlWithParams = `${apiURL}?${params.toString()}`;
    return this.apiService.query(urlWithParams);
  }
  private scrollToFirstInvalidControl(id: string) {

    let form = document.getElementById(id);
    let firstInvalidControl = form.getElementsByClassName('ng-invalid')[0];
    if (firstInvalidControl != undefined) {
      firstInvalidControl.scrollIntoView();
      (firstInvalidControl as HTMLElement).focus();
    }
  }
  get rtrContent(): UntypedFormArray | null {
    return this.rtrformgrp ? this.rtrformgrp.get('rtrcontent') as UntypedFormArray : null;
  }

  rtrlength(): number {
    return (this.rtrformgrp.get('rtrcontent') as UntypedFormArray).controls.length;
  }

  terms(event) {
    this.termAndCondition = event;
    this.selectedCandidate.emit({ value: this.selectedCandidateData, formData: this.rtrContent, terms: this.termAndCondition, resumes: this.applyResumeUploadData });
  }

  isApiCallInProgress: boolean = false

  candidateIdrtr;

  // duplicateinvite: boolean = false
  apply(values: any, connectionTemplate: TemplateRef<any>, jobsupplytemplate: TemplateRef<any>) {

    this.gigsumoService.candidateInviteBtnClicked = true
    this.passCandidateData = values;
    this.focus = 'candidate';
    // if (values.isFeatured) {
    // this.proceedToApply(values, jobsupplytemplate);
    // } else if (!values.isFeatured) {
    //if (values.connectionStatus === 'CONNECTED') {
    this.proceedToApply(values, jobsupplytemplate);
    //} else if (values.connectionStatus !== 'CONNECTED') {
    //this.proceedToApply(values, jobsupplytemplate);
    // to be used later
    // this.openConnectionTemplate(values, connectionTemplate);

    //}
    //}
  }

  async proceedToApply(values, jobsupplytemplate) {
    try {
      this.util.startLoader();
      const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
      let { userDetail, isExpired, membershipType } = userData;
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      if (userDetail && userDetail.userPlanAndBenefits && userDetail.userPlanAndBenefits.benefitsUsages) {
        userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
          if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
            availablePoints = ele.available;
            actualPoints = ele.actual;
            utilizedPoints = ele.utilized;
            promotional = ele.promotional;
          }
        });
      } else {
        this.invitemodalopen(values, jobsupplytemplate);
        this.util.stopLoader();
        return;
      }
      if (isExpired) {
        let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

        if (['Starter', 'Growth', 'ScaleX'].includes(membershipType)) {
          popupType = "LIMIT";
        }

        this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);

        this.gigsumoService.candidateInviteBtnClicked = false
        this.util.stopLoader();
        return;
      } else {
        this.invitemodalopen(values, jobsupplytemplate);
      }
    } catch (error) {
    } finally {
      this.util.stopLoader();
    }
  }
  invitemodalopen(values, jobsupplytemplate) {
    values.userId = localStorage.getItem('userId');
    values.candidatefilter = true;
    values.getResume = false;
    values.userType = values.user.userType;
    const config: ModalOptions = { class: 'modal-lg', backdrop: 'static', keyboard: false };

    this.candidateSupplyRef = this.modalService.show(jobsupplytemplate, config);

    // Load NewJobComponent dynamically after modal is rendered
    setTimeout(() => {
      this.cdr.detectChanges();
      this.loadNewJobComponent();
    }, 150);

    this.gigsumoService.candidateInviteBtnClicked = false;
  }

  ngAfterViewInit(): void {

  }


  like(values: any) {
    if (values.createdBy != localStorage.getItem('userId')) {
      let datas: any = {};
      if (values.isLiked == false || values.isLiked == null) {
        datas.likeStatus = "LIKE"
      } else if (values.isLiked == true) {
        datas.likeStatus = "UNLIKE"
      }

      datas.candidateId = values.candidateId
      datas.userId = localStorage.getItem('userId');
      this.util.startLoader();
      this.apiService.updatePut("candidates/updateCandidateLiked", datas).subscribe((res) => {
        if (res.code == '00000') {
          this.util.stopLoader();
          this.passValues.forEach(ele => {
            if (res.data.candidateData.candidateId == ele.candidateId) {
              ele.isLiked = res.data.candidateData.isLiked;
              ele.likesCount = res.data.candidateData.likesCount;
            }
          })

        }

      }, err => {
        this.util.stopLoader();
      });
    } else {
      this.goTo(values, 'Clike-like')
    }
  }


  submissionFilterRoute(items) {
    this.candidateListing.emit(`SUBMISSION_ROUTE|${items.candidateId}`)
  }

  redirect_invite(val, path) {
    if (path == 'jobsApplied') {
      let data = JSON.parse(localStorage.getItem('candidateForm'));
      val.seletedFilter = data.submissionFilters;
      this.router.navigate(['newcandidates/jobsApplied'], { queryParams: val })
    }
  }

  goTo(values: any, param) {
    this.selectedItem = values.candidateId;
    if (this.updateCandidateModule) {

      if (values.createdBy == this.userId) {
        if (param == 'jobsApplied') {
          this.updateCandidateModule.jobDetails.apply(this.updateCandidateModule.source, [param, { value: values, for: "TAB_ROUTE" }])
        } else if (param == 'views') {
          this.updateCandidateModule.jobDetails.apply(this.updateCandidateModule.source, [param, { value: values, for: "TAB_ROUTE" }])
        }
        else if (param == 'Clike-like') {
          this.updateCandidateModule.jobDetails.apply(this.updateCandidateModule.source, [param, { value: values, for: "TAB_ROUTE" }])
        } else if (param == 'cInvited' && values.interestShownCount > 0) {
          this.updateCandidateModule.jobDetails.apply(this.updateCandidateModule.source, [param, { value: values, for: "TAB_ROUTE" }])
        }
      }
      else if (values.createdBy != this.userId) {
        if (param == 'jobsApplied') {
          this.updateCandidateModule.jobDetails.apply(this.updateCandidateModule.source, [param, { value: values, for: "TAB_ROUTE" }])
        } else if (param == 'views' && values.viewedByCount > 0) {
          this.updateCandidateModule.jobDetails.apply(this.updateCandidateModule.source, ["profileSummary", { value: values, for: "TAB_ROUTE" }])
        }
        else if (param == 'cInvited' && values.interestShownCount > 0) {
          this.updateCandidateModule.jobDetails.apply(this.updateCandidateModule.source, [param, { value: values, for: "TAB_ROUTE" }])
        }
      }

    }

  }

  async open(values: any) {
    if (!this.filtersApplied && values.status != 'BLOCKED' && !values.isViewed && values.createdBy != this.userId) {


      this.updateCandidateView(values);

    }
    else {
      this.selectedItem = values.candidateId;
      this.updateCandidateModule.jobDetails.apply(this.updateCandidateModule.source, [values, { value: null, for: "CANDIDATE_DETAIL" }]);
    }
  }

  // Card click handler — bubbles every click to the document so ngx-bootstrap
  // can auto-close other open dropdowns (the V3 detail-header "More" menu in
  // particular). Skips the candidate `open()` navigation when the click came
  // from the inline kebab so it can do its own dropdownToggle work without
  // also triggering the row open. Replaces the previous inline
  // `(click)="$event.stopPropagation()"` on the kebab — that approach blocked
  // the document listener and left two dropdowns visible at once.
  onCardClick(event: Event, items: any) {
    const target = event.target as HTMLElement | null;
    if (target && target.closest('.jc-v3-jc-kebab')) {
      return;
    }
    this.open(items);
  }

  // Tracks which card's kebab (More) menu is open so only ONE is ever open.
  // ngx-bootstrap's dropdownToggle stops propagation internally, so a second
  // card's toggle click never reaches the first dropdown's outside-click
  // handler and the previous menu stayed open. Binding [isOpen] to a single
  // id closes the others the moment a new one opens.
  openKebabId: any = null;
  onKebabToggle(open: boolean, items: any) {
    if (open) {
      this.openKebabId = items?.candidateId;
      // Cross-close: stopPropagation() on the triggers means the outside-click
      // never reaches an open status menu, so close it here explicitly.
      this.openStatusId = null;
      // Notify detail header to close its dropdown
      this.searchData.setDropdownState('kebab', true);
    } else if (this.openKebabId === items?.candidateId) {
      this.openKebabId = null;
      this.searchData.setDropdownState('kebab', false);
    }
  }

  // Same single-open pattern for the status (Available/Unavailable) dropdown.
  // The pill's (click)="$event.stopPropagation()" stops the toggle click from
  // reaching another open dropdown's outside-click handler, so without this an
  // already-open status menu stayed open when a second card's was opened.
  openStatusId: any = null;
  onStatusToggle(open: boolean, items: any) {
    if (open) {
      this.openStatusId = items?.candidateId;
      // Cross-close the kebab menu (see onKebabToggle).
      this.openKebabId = null;
      // Notify detail header to close its dropdown
      this.searchData.setDropdownState('status', true);
    } else if (this.openStatusId === items?.candidateId) {
      this.openStatusId = null;
      this.searchData.setDropdownState('status', false);
    }
  }

  updateCandidateView(values) {
    this.util.startLoader();
    this.candidateService.updateCandidateViewed(values).subscribe((res) => {
      this.util.stopLoader();
      if (res.code === "00000") {
        values.isViewed = true;
        this.selectedItem = values.candidateId;
        this.updateCandidateModule.jobDetails.apply(this.updateCandidateModule.source, [values, { value: null, for: "CANDIDATE_DETAIL" }]);
      }
    }, err => {
      this.util.stopLoader();
    });
  }


  backdropConfig = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
    // scroll
  };
  candidateJobTitleList: any = [];
  modalRef: BsModalRef;
  otherStatesList: any = [];
  candidatePostForm: UntypedFormGroup;
  get candidateControls() {
    return this.candidatePostForm.controls
  }
  currentOrganizationDetail: WorkExperience;
  //open candidate modal in candidate page by monisha
  @ViewChild(CandidateTemplateComponent, { static: false }) CandidateTemplateComponent: CandidateTemplateComponent;
  async edit(item) {
    if (this.CandidateTemplateComponent) {
      this.CandidateTemplateComponent.opencandidateModal(item); // Open the modal
    }
  }
  @Output() candidateReloadFromComponent = new EventEmitter<any>();
  @Output() candidateFilterFromComponent = new EventEmitter<any>();
  //emit event in candidate page by monisha
  oncandidateReload(event: any) {
    this.candidateReloadFromComponent.emit(event);
  }
  //emiy event in new candidate
  oncandidateFilterReload(event: any) {
    this.candidateFilterFromComponent.emit(event);
  }
  submitResume() {
    console.log('Submitting resume, data length:', this.applyResumeUploadData.length);
    
    // // Make sure the array is initialized
    // if (!this.applyResumeUploadData) {
    //   this.applyResumeUploadData = [];
    // }
  
    if (this.applyResumeUploadData.length > 0) {
      // Check if there's data for the selected candidate
      let data = this.applyResumeUploadData.find(
        item => item.candidateId === this.selectedResumeAttached.candidateId
      );
      
      if (data != undefined) {
        // Success path - emit the data
        // console.log('Emitting resume data:', this.applyResumeUploadData);
        // console.log('this.selectedCandidateData', this.selectedCandidateData)
        // this.selectedCandidateData['resumes'] = this.applyResumeUploadData

        this.selectedCandidateData.forEach(candidate => {
          // Find matching resume data by candidateId
          const resumeData = this.applyResumeUploadData.find(
            resumeItem => resumeItem.candidateId === candidate.candidateId
          );
          
          // If a matching resume is found, append it to the candidate's resumes array
          if (resumeData) {
            console.log('Matching resume found for candidate:', candidate.candidateId);
            
            // Initialize resumes array if it doesn't exist
            if (!candidate.resumes) {
              candidate.resumes = [];
            }
            
            // Add the resume to the candidate's resumes array
            candidate.resumes.push({
              resumeFile: resumeData.resume,
              resumeName: resumeData.resumeName,
              isDefault: true // Set as default resume if needed
            });
            
            // Update resumeAttached flag to true
            candidate.resumeAttached = true;
          }
        });
        
        this.selectedCandidate.emit({ 
          value: this.selectedCandidateData, 
          formData: this.rtrContent, 
          terms: this.termAndCondition, 
          resumes: this.applyResumeUploadData
        });
        
        // Update form validations
        this.rtrContent.controls.forEach((ele, index) => {
          if (ele.get('candidateId').value === this.selectedResumeAttached.candidateId) {
            this.rtrContent.at(index).get('resumeAttached').clearValidators();
            this.rtrContent.at(index).get('resumeAttached').updateValueAndValidity();
          }
        });
        
        this.close(false);
      } else {
        Swal.fire({
          icon: "info",
          title: "Resume is not attached for the selected candidate.",
          showDenyButton: false,
          timer: 3000,
        });
      }
    } else {
      Swal.fire({
        icon: "info",
        title: "Resume is not attached.",
        showDenyButton: false,
        timer: 3000,
      });
    }
  }


  getResumeError(index: number) {
    return this.rtrContent.at(index).get('resumeAttached').errors;
  }

  updatePrimaryresumeAPI(file: File) {
    // this.selectedResumeAttached.primaryResume=true;
    this.PrimaryResumeFormData = new FormData();
    this.PrimaryResumeFormData.append("file", file);
    this.PrimaryResumeFormData.append("candidate", new Blob([JSON.stringify(this.selectedResumeAttached)], { type: "application/json" }));
    this.util.startLoader()
    this.API.updatePut('candidates/updateResumeRequestStatus', this.PrimaryResumeFormData).subscribe(res => {
      this.modalRef.hide();
      this.util.stopLoader();
      if (res.code == '00000') {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Updated Successfully",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    })


  }

  selectedResumeAttached: any = [];
  openJobApplyResumeUpload(template: TemplateRef<any>, index: number) {
    this.selectedResumeAttached = this.passValues[index];

    // Reset file input state and check if this candidate already has a file uploaded
    const existingFile = this.applyResumeUploadData.find(
      item => item.candidateId === this.selectedResumeAttached.candidateId
    );

    if (existingFile) {
      // Restore the file display if one was previously uploaded for this
      // candidate. prepareFilesList() stores the File under `resume` (not
      // `file`), so read that; keep `.file` as a fallback for entries created
      // by the legacy jobApplyprepareFilesList() path.
      this.fileDragdrop = existingFile.resume || existingFile.file;
    } else {
      // No file for this candidate - show empty upload state
      this.fileDragdrop = null;
    }
    this.resumeupload = null;

    // Clear file input value for fresh selection
    try {
      const fileInput = document.getElementById('fileDropRef') as HTMLInputElement;
      if (fileInput) fileInput.value = '';
    } catch (e) { /* ignore */ }

    this.modalRef = this.modalService.show(template, {
      animated: true,
      backdrop: "static",
      keyboard: false
    });
  }



  candidateSubmit: boolean = false



  primarySkillsSelected = [];
  secondarySkillsSelected = [];
  stateListCA: any = []
  stateListIN: any = []
  stateListAU: any = []
  countryList: any = [];
  submit: boolean = false
  getCountries() {
    this.countryList = [];
    this.util.startLoader();
    this.apiService.query("country/getAllCountries").subscribe((res) => {
      // this.util.stopLoader();
      res.forEach((ele) => {
        this.countryList.push(ele);
      });
    }, err => {
      this.util.stopLoader();
    });
  }

  checkspace(event: any): boolean {
    return super.validSpace(event);
  }

  years: any = []
  generateYears() {
    // var max = new Date().getFullYear();
    // var min = max - 80;
    for (var i = 0; i <= 20; i++) {
      this.years.push(i);
    }
  }

  organizationList: any = []
  primarySkillsList: any = []
  secondarySkillsList: any = []
  skillsList: any = []
  payTypeList: any = []
  clientTypeList: any = []
  clientNameList: any = []
  clientNameList1: any = []
  durationTypeList: any = []
  usStatesList = []
  jobClassificationList: any = []
  commonVariables: any = {};
  totalExperienceList = []
  periodList = []

  recruiterTitleList: any = []
  engagementTypeList = []
  workAuthorizationList: any = []
  jobPostForm: UntypedFormGroup;
  currentTime: any;
  maxDate: any
  isSelected(id: number): boolean {
    return this.gigsumoService.isSelected(id, this.selectedNetworks);
  }

  onCheckboxChangenetwork(id: number, checked: boolean, form: FormGroup): void {
    this.selectedNetworks = this.gigsumoService.onCheckboxChange(
      id,
      checked,
      this.selectedNetworks,
      form,
      'selectedNetworks'
    );
  }
  selectedNetworks: number[] = [];
  networkGroups: any[] = [];
  networks: any[] = [];
  groupedNetworks: any = {};
  selectedCountries: boolean = false
  onTargetRateTyped(value, param) {
    this.typeTargetValue = value
  }

  modalRef2: BsModalRef | null;
  img: any = {};
  img4: any = {};


  resumeupload;

  // prepareFilesList(files: File) {
  //   if (files[0].size > this.fileSize) {
  //     Swal.fire("", `${this.IMAGE_ERROR}`, "info");
  //     $("#fileDropRef")[0].value = '';
  //     return true;
  //   }
  //   this.fileDragdrop = files[0];
  //   this.resumeupload = files[0];

  //   var fromate = ['application/pdf', 'application/docx', 'application/doc', 'text/plain', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword']

  //   if (fromate.includes(files[0].type)) {
  //     this.fileDragdrop = files[0];
  //     this.resumeupload = files[0];
  //     if (fromate.includes(files[0].type)) {
  //       this.fileDragdrop = files[0];
  //       this.applyResumeUploadData.push({
  //         file: files[0],
  //         candidateId: this.selectedResumeAttached.candidateId
  //       });
  //       // this.selectedCandidate.emit({value : this.selectedCandidateData , formData : this.rtrContent , terms : this.termAndCondition,resumes:this.applyResumeUploadData});

  //     }
  //   } else {
  //     this.fileDragdrop = "";
  //     this.resumeupload = "";
  //     Swal.fire({
  //       icon: "info",
  //       title: "Please upload a valid format.",
  //       showDenyButton: false,
  //       timer: 3000,
  //     })
  //   }

  // } 

  close(isValid: boolean = true) {
    // Reset UI state BEFORE hiding modal (while element still exists)
    this.fileDragdrop = null;
    this.resumeupload = null;

    // Safe file input clear - use try/catch to prevent breaking the flow
    try {
      const fileInput = document.getElementById('fileDropRef') as HTMLInputElement;
      if (fileInput) fileInput.value = '';
    } catch (e) { /* ignore */ }

    // Remove from applyResumeUploadData ONLY when the user Cancels/closes
    // (isValid === true). On OK (submitResume calls close(false)) the resume
    // MUST be kept — otherwise it's stripped right after being attached, so a
    // later re-emit (e.g. toggling a candidate) sends an empty resumes array
    // and the file never reaches the jobs/updateJobApplied payload. With
    // multiple candidates, each OK previously wiped the prior candidate's
    // resume, leaving only the last one.
    if (isValid && this.selectedResumeAttached && this.selectedResumeAttached.candidateId) {
      this.applyResumeUploadData = this.applyResumeUploadData.filter(
        item => item.candidateId !== this.selectedResumeAttached.candidateId
      );

      // Reset resumeAttached to empty (not `false`): Validators.required treats
      // the boolean `false` as a present value, so it would NOT flag the control
      // as required — making the button wrongly show "Resume Attached" after the
      // popup is closed without uploading. '' matches the control's initial
      // value and is correctly flagged as required.
      this.rtrContent.controls.forEach((ele) => {
        if (ele.get('candidateId').value === this.selectedResumeAttached.candidateId) {
          ele.get('resumeAttached').setValue('');
          ele.get('resumeAttached').updateValueAndValidity();
        }
      });
    }

    // Hide modal AFTER cleanup
    this.modalRef.hide();

    if (isValid) {
      this.rtrContent.controls.forEach((ele, index) => {
        if (ele.get('candidateId').value === this.selectedResumeAttached.candidateId) {
          this.rtrContent.at(index).get('resumeAttached').setValidators([Validators.required]);
          this.rtrContent.at(index).get('resumeAttached').updateValueAndValidity();
        }
      });
    }
  }

  removeFile() {
    this.fileDragdrop = "";

    // Safe file input clear
    try {
      const fileInput = document.getElementById('fileDropRef') as HTMLInputElement;
      if (fileInput) fileInput.value = '';
    } catch (e) { /* ignore */ }

    this.applyResumeUploadData = [];
  }

  applyResumeUploadData: any[] = [];
  jobApplyprepareFilesList(files: File) {
    if (files[0].size > this.fileSize) {
      Swal.fire("", `${this.IMAGE_ERROR}`, "info");
      // Safe file input clear
      try {
        const fileInput = document.getElementById('fileDropRef') as HTMLInputElement;
        if (fileInput) fileInput.value = '';
      } catch (e) { /* ignore */ }
      return true;
    }

    var fromate = ['application/pdf', 'application/docx', 'application/doc', 'text/plain', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword']

    if (fromate.includes(files[0].type)) {
      this.fileDragdrop = files[0];
      this.applyResumeUploadData.push({
        file: files[0],
        candidateId: this.selectedResumeAttached.candidateId
      });
      // this.selectedCandidate.emit({value : this.selectedCandidateData , formData : this.rtrContent , terms : this.termAndCondition,resumes:this.applyResumeUploadData});

    } else {
      this.fileDragdrop = "";
      Swal.fire({
        icon: "info",
        title: "Please upload a valid format.",
        showDenyButton: false,
        timer: 3000,
      })
    }
  }

  onChangePeriod(value) {

  }
  closemodel() {
    this.modalRef.hide();
  }
  uploadFiles: Array<any> = [];
  serverCurrentDate: string;
  servertimedate: string;
  disable_for_draft: boolean = false;

  connect(values) {

    var data: any = {};
    data.userId = values.createdBy;
    data.requestedBy = localStorage.getItem("userId");
    this.util.startLoader();
    this.apiService.create("user/connect", data).subscribe((res) => {
      // Stop for every response code — unhandled codes used to leave the loader spinning.
      this.util.stopLoader();
      if (res.code == "00000") {
        this.util.stopLoader();
        // this.connectionStatus = 'REQUEST_SENT';
        if (values) {
          values = { ...values, connectionStatus: 'REQUEST_SENT' };
          this.commonValues.setCandidateData(values);
        }
        //message to show connect request is sent successfully
        setTimeout(function () {
          Swal.fire({
            icon: "success",
            title: "Request sent successfully",
            showConfirmButton: false,
            timer: 2000,
          });
        }, 200);

      } else if (res.code == "88888") {
        this.util.stopLoader();
        Swal.fire({
          icon: "info",
          title: "Request failed",
          text: "Request coundn't be sent now. Please try after some time.",
          showConfirmButton: false,
          timer: 3000,
        });
      } else if (res.code == 'U0031') {
        this.util.stopLoader()
      }
    }, err => {
      this.util.stopLoader();

    });
  }

  //candidate page to profile summary details update by monisha
  updateCandidateObject(candidateObject): void {
    this.passValues.forEach((res, index) => {
      if (res.createdBy == candidateObject.createdBy) {
        this.passValues[index] = { ...this.passValues[index], connectionStatus: candidateObject.connectionStatus }
      }
    });
  }

  applyResumeUpload(files) {
    this.tempFile = files[0];
    this.jobApplyprepareFilesList(files);
  }
  otherSelectedStates: any = []





  openMessage(seletedItem) {
    this.gigsumoService.candidateInviteBtnClicked = false;
    this.messagemodelflag = false;
    if (seletedItem.createdBy == this.userId) {
      seletedItem.owner = true;
    } else {
      seletedItem.owner = false;
    }
    setTimeout(() => {
      seletedItem.userId = seletedItem.createdBy;
      this.seletedChatItem = seletedItem;
      this.messageData = [];
      this.messagemodelflag = true;
      seletedItem.groupType = "CANDIDATE";
      seletedItem.messageType = "CANDIDATE";
      seletedItem.id = seletedItem.candidateId;
      this.messageData = seletedItem;

    }, 1000);
  }
  async openMessagecheckInteraction(seletedItem, connectionTemplate?: TemplateRef<any>) {
    // Own candidate: the owner can always chat with their own candidate for free.
    // Open the chat directly and skip the interaction/plan checks entirely -
    // no message/contact/exist, no findUserPlanBenefits / findPlans. The chat
    // modal loads the thread via /findContactsByRefererId.
    if (seletedItem?.createdBy && seletedItem.createdBy === this.userId) {
      this.openMessage(seletedItem);
      return;
    }
    // Universal first-interaction: exist-first — skip the ACTIVE_INTERACTIONS gate
    // (findUserPlanBenefits / findPlans) when this candidate's interaction was
    // already consumed (existing chat / prior invite / resume-request — backend
    // `alreadyConsumed`). Otherwise gate as before. Fails safe.
    if (await this.planService.isInteractionAlreadyConsumed(seletedItem?.candidateId, 'CANDIDATE')) {
      this.chatuser(seletedItem);
      return;
    }
    try {
      this.util.startLoader();
      const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
      let { userDetail, isExpired, membershipType } = userData;
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      if (userDetail && userDetail.userPlanAndBenefits && userDetail.userPlanAndBenefits.benefitsUsages) {
        userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
          if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
            availablePoints = ele.available;
            actualPoints = ele.actual;
            utilizedPoints = ele.utilized;
            promotional = ele.promotional;
          }
        });
      } else {
        this.util.startLoader();
        this.chatuser(seletedItem);

        return;
      }

      if (isExpired) {
        let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

        if (['Starter', 'Growth', 'ScaleX'].includes(membershipType)) {
          popupType = "LIMIT";
        }

        this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);

      } else {
        this.util.startLoader();
        this.chatuser(seletedItem);

      }
    } catch (error) {
    } finally {
      setTimeout(() => {
        this.util.stopLoader();
      }, 1500);
    }

  }

  chatuser(seletedItem, connectionTemplate?: TemplateRef<any>) {

    this.gigsumoService.candidateInviteBtnClicked = true
    this.passCandidateData = seletedItem;
    this.focus = 'candidate';
    if (seletedItem.isFeatured || (seletedItem.createdBy == this.userId)) {
      this.openMessage({ ...seletedItem });
    } else if (!seletedItem.isFeatured) {
      //if (seletedItem.connectionStatus === 'CONNECTED') {
      this.openMessage({ ...seletedItem });
      // } else if (seletedItem.connectionStatus !== 'CONNECTED') {
      // this.gigsumoService.candidateInviteBtnClicked = false;
      //this.openMessage(seletedItem);
      // to be used later
      // this.openConnectionTemplate(seletedItem, connectionTemplate);
      // }
    }
  }

  closeMessage(event) {
    this.messagemodelflag = false;
    // this._socket.ngOnDestroy();
  }

  //candidate draft delete function by monisha
  deletecandidate(id: any) {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    })
    swalWithBootstrapButtons.fire({
      title: 'Do you wish to discard?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.util.startLoader();
        this.apiService.delete('candidates/delete/' + id).subscribe(res => {
          if (res.code == "00000") {
            this.util.stopLoader();
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Discarded Sucessfully',
              showConfirmButton: false,
              timer: 1500
            })
            this.candidateReload.emit('discard');
          }
        })
      }
    });
  }
  connectionStatus: string;
  connectionRequestRef: BsModalRef;
  values: any;
  counterpartsDetails: any;
  @ViewChild("connectionTemplate") connectionTemplate: TemplateRef<any>;
  openConnectionTemplate(values, connectionTempate?: TemplateRef<any>) {

    this.connectionStatus = values.connectionStatus;
    this.values = values;
    this.counterpartsDetails = values.user;
    const config: ModalOptions = { class: 'modal-md', backdrop: 'static', keyboard: false };
    this.connectionRequestRef = this.modalService.show(connectionTempate, config);
  }


  onFileDropped(files: any) {
    console.log('Files dropped:', files);
    if (files && files.length > 0) {
      this.prepareFilesList(files);
    }
  }

  fileBrowseHandler(files: FileList) {
    console.log('Files browsed:', files);
    if (files && files.length > 0) {
      this.prepareFilesList(files);
    }
  }
  fileDragdrop: any = null;
  @ViewChild('fileDropRef') fileDropRef: ElementRef;
  prepareFilesList(files: Array<File> | FileList) {
    // Ensure we have a valid file
    if (!files || files.length === 0) {
      console.log('No files to process');
      return;
    }
  
    const file = files[0]; // Get the first file
    console.log('Processing file:', file);
  
    // Check file size
    if (file.size > this.fileSize) {
      Swal.fire("", `${this.IMAGE_ERROR}`, "info");
      if (this.fileDropRef && this.fileDropRef.nativeElement) {
        this.fileDropRef.nativeElement.value = '';
      }
      return;
    }
  
    // Define acceptable formats
    const acceptableFormats = [
      'application/pdf',
      'application/docx',
      'application/doc',
      'text/plain',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword'
    ];

    console.log('File type:', file.type);

    // Accept by MIME type OR file extension — browsers often report an empty or
    // non-standard `file.type` for .doc/.docx (and some drag-dropped files),
    // which would otherwise bounce valid resumes as "invalid format".
    const fileName = (file.name || '').toLowerCase();
    const acceptableExtensions = ['.pdf', '.doc', '.docx', '.txt'];
    const isTypeOk = acceptableFormats.includes(file.type);
    const isExtOk = acceptableExtensions.some(ext => fileName.endsWith(ext));

    // Check if file type is acceptable
    if (isTypeOk || isExtOk) {
      // Create a more robust file object with properties your template can display
      this.fileDragdrop = {
        file: file,
        fileName: file.name,
        fileSize: this.formatBytes(file.size),
        fileType: file.type
      };
      console.log('File accepted:', this.fileDragdrop);
      this.resumeupload = file;
  
      // Initialize the array if it doesn't exist
      if (!this.applyResumeUploadData) {
        this.applyResumeUploadData = [];
      }
  
      // Add to applyResumeUploadData if selectedResumeAttached is available
      if (this.selectedResumeAttached && this.selectedResumeAttached.candidateId) {
        // Check if entry already exists for this candidate
        const existingIndex = this.applyResumeUploadData.findIndex(
          item => item.candidateId === this.selectedResumeAttached.candidateId
        );
  
        const resumeData = {
          candidateId: this.selectedResumeAttached.candidateId,
          resume: file,
          resumeName: file.name
        };
  
        if (existingIndex >= 0) {
          // Update existing entry
          this.applyResumeUploadData[existingIndex] = resumeData;
        } else {
          // Add new entry
          this.applyResumeUploadData.push(resumeData);
        }
  
        console.log('Updated applyResumeUploadData:', this.applyResumeUploadData);
  
        // Update form validation
        this.rtrContent.controls.forEach((ele, index) => {
          if (ele.get('candidateId').value === this.selectedResumeAttached.candidateId) {
            ele.get('resumeAttached').setValue(true);
            ele.get('resumeAttached').updateValueAndValidity();
          }
        });
      } else {
        console.log('Warning: No selectedResumeAttached.candidateId available');
      }
    } else {
      console.log('Invalid file format');
      this.fileDragdrop = null;
      this.resumeupload = null;
      Swal.fire({
        icon: "info",
        title: "Please upload a valid format.",
        showDenyButton: false,
        timer: 3000,
      });
    }
  }
  

  // Update removeFiles to also remove from applyResumeUploadData
  removeFiles() {
    // Remove from applyResumeUploadData array if applicable
    if (this.selectedResumeAttached && this.selectedResumeAttached.candidateId) {
      this.applyResumeUploadData = this.applyResumeUploadData.filter(
        item => item.candidateId !== this.selectedResumeAttached.candidateId
      );

      // Update form validation. Reset to '' (not `false`) so Validators.required
      // flags it — `false` is treated as present and would leave the button
      // showing "Resume Attached" after the file is removed.
      this.rtrContent.controls.forEach((ele) => {
        if (ele.get('candidateId').value === this.selectedResumeAttached.candidateId) {
          ele.get('resumeAttached').setValue('');
          ele.get('resumeAttached').updateValueAndValidity();
        }
      });
    }

    this.fileDragdrop = null;
    this.resumeupload = null;

    // Clear file input value (enables re-selecting same file)
    // Try ViewChild first, then fallback to getElementById
    if (this.fileDropRef && this.fileDropRef.nativeElement) {
      this.fileDropRef.nativeElement.value = '';
    } else {
      // Safe fallback for modal contexts
      const fileInput = document.getElementById('fileDropRef') as HTMLInputElement;
      if (fileInput) fileInput.value = '';
    }
  }

  clearAndOpenFileInput() {
    if (this.fileDropRef?.nativeElement) {
      this.fileDropRef.nativeElement.value = '';
      this.fileDropRef.nativeElement.click();
    }
  }

  // Helper function to format bytes
  formatBytes(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  /**
   * Dynamically loads NewJobComponent to break circular dependency
   * Called when job listing modal needs to be displayed
   */
  async loadNewJobComponent(retryCount: number = 0) {
    const maxRetries = 5;

    // If container hasn't been found yet, try to get it from the modal's DOM
    if (!this.newJobContainer) {
      if (retryCount < maxRetries) {
        // Try to find the container element in the modal's DOM
        const containerElement = document.getElementById('newJobDynamicContainerCandidatesPage');

        if (!containerElement) {
          const delay = 50 * Math.pow(2, retryCount); // 50ms, 100ms, 200ms, 400ms, 800ms
          console.log(`[CandidatesPage] NewJobContainer not ready, retrying in ${delay}ms (attempt ${retryCount + 1}/${maxRetries})`);
          setTimeout(() => this.loadNewJobComponent(retryCount + 1), delay);
          return;
        }
      } else {
        console.error('[CandidatesPage] NewJobContainer not available after maximum retries');
        return;
      }
    }

    console.log('[CandidatesPage] Proceeding with dynamic component load...');

    try {
      console.log('[CandidatesPage] Loading NewJobComponent dynamically...');

      // Dynamic import to break circular dependency
      const { NewJobComponent } = await import('../../../page/homepage/layout-jobs/new-job/new-job.component');

      // Get the container element
      const containerElement = document.getElementById('newJobDynamicContainerCandidatesPage');

      if (containerElement) {
        // Clear previous content
        containerElement.innerHTML = '';

        // Use ApplicationRef to create and attach the component
        const componentFactory = this.injector.get(ComponentFactoryResolver);
        const factory = componentFactory.resolveComponentFactory(NewJobComponent);

        // Create the component
        this.newJobComponentRef = factory.create(this.injector);

        // Set inputs (maintaining all @Input decorators)
        this.newJobComponentRef.instance.focus = this.focus;
        this.newJobComponentRef.instance.screenName = 'invite-job-listing';
        this.newJobComponentRef.instance.filterData = this.passCandidateData;

        // Attach the component's host view to the application
        const appRef = this.injector.get(ApplicationRef);
        appRef.attachView(this.newJobComponentRef.hostView);

        // Append the component's DOM element to our container
        const domElem = (this.newJobComponentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
        containerElement.appendChild(domElem);

        // Trigger change detection
        this.newJobComponentRef.changeDetectorRef.detectChanges();

        console.log('[CandidatesPage] NewJobComponent loaded successfully');
      } else {
        console.error('[CandidatesPage] Container element not found in DOM');
      }
    } catch (error) {
      console.error('[CandidatesPage] Error loading NewJobComponent:', error);
    }
  }


  getActiveUrgencyDays(candidate: any): number | null {
    if (!candidate?.isFeatured) return null;

    const now = new Date();
    let urgencyEndDate: Date;

    if (candidate?.featuredConsumptions?.length > 0) {
      const lastConsumption = candidate.featuredConsumptions[candidate.featuredConsumptions.length - 1];
      const fromDate = new Date(lastConsumption.fromDate);
      const dayCount = lastConsumption.dayCount || 1;
      urgencyEndDate = new Date(fromDate.getTime() + (dayCount * 24 * 60 * 60 * 1000));
    } else if (candidate?.featuredUpdatedOn) {
      const featuredDate = new Date(candidate.featuredUpdatedOn);
      urgencyEndDate = new Date(featuredDate.getTime() + (2 * 24 * 60 * 60 * 1000));
    } else {
      return 1;
    }

    const diffMs = urgencyEndDate.getTime() - now.getTime();
    const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    return days > 0 ? days : 1;
  }

}


